import { FullScreen } from 'ol/control';
import { default as RControlBase } from './RControlBase';
/**
 * A control for switching to full-screen mode
 *
 * Requires an `RMap` context
 * */
export default class RFullScreen extends RControlBase {
    constructor(props) {
        super(props);
        this.ol = new FullScreen(this.toOLProps(props));
    }
    toOLProps(props) {
        return Object.assign(Object.assign({}, super.toOLProps(props)), { source: props.source, label: props.label, labelActive: props.labelActive, tipLabel: props.tipLabel });
    }
}
//# sourceMappingURL=RFullScreen.js.map